export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-excel-e466ee7a8db598e13f79f4763e7b2988.svg";